/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

export interface FirmwareDto {
  file: Blob;
  /** Name of the firmware */
  name: string;
  /** Model id of the firmware (UUID) */
  model: string;
  /** Version of the firmware */
  version: string;
}
